import "../../styles/BirthdayParty/BirthdayPartyCommons.css"
import "../../styles/Birthday.css"

import { useEffect, useState, useCallback } from "react"



function BirthdayAdmin() {
    const [isConnected, setConnected] = useState(false)
    const [animationName, setAnimatioName] = useState("")
    const [quantity, setQuantity] = useState(10)
    const [players, setPlayers] = useState([])
    const [childs, setchilds] = useState(false)
    const [item, setItem] = useState({})

    const handleVerify = (e) => {
        e.preventDefault()
        if(e.target.value === "cestmoi") {
            setConnected(true)
        }
    }

    const handleSendInfo = async (e, route, body) => {
        e.preventDefault()

        await fetch(route, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        }).then((res) => {
            res.json()
            console.log(res.json());
        }).catch((err) => {
            console.error(err);
            
        })

    }

    const handleGetPlayers = async (e) => {
        e.preventDefault()

        await fetch(`https://api.kenzo-simon.fr/birthday/admin/generate-list`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                quantity: quantity,
                childs: childs
            })
        }).then((res) => res.json()).then((data) => {
            if(data.players) {
                setPlayers(data.players)
                console.log(data.players);
            }
        }).catch((err) => {
            console.error(err);
            
        })

    }

    const handleGetItem = async (e) => {
        e.preventDefault()

        await fetch(`https://api.kenzo-simon.fr/birthday/admin/get-item`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                nobody: true
            })
        }).then((res) => res.json()).then((data) => {
            if(data.item) {
                setItem(data.item)
                console.log(data);
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    const handleChangePlayer = async (playerId) => {
        await fetch(`https://api.kenzo-simon.fr/birthday/admin/replace-player`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                replaceId: playerId,
                childs: childs
            })
        }).then((res) => res.json()).then((data) => {
            if(data.newPlayer) {
                setPlayers((currentPlayers) =>
                    currentPlayers.map((player) =>
                        player.internId === playerId
                            ? data.newPlayer
                            : player
                    )

                )
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    const handleKeepPlayer = async (playerId) => {
        await fetch(`https://api.kenzo-simon.fr/birthday/admin/keep-player`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                keepId: playerId
            })
        }).then((res) => res.json()).then((data) => {
        }).catch((err) => {
            console.error(err);
        })
    }

    return (
        <div className="body body-birthday_admin">
            {isConnected ? (
                <>
                <div className="birth-adminpage">
                    <div className="admin-part admin-part-1">
                        <button className="birth-button" onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/pause`, { state: true })}>
                            Pause le screen
                        </button>

                        <button className="birth-button" onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/pause`, { state: false })}>
                            Resume le screen
                        </button>

                        <button className="birth-button" onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/set-qrcode`, { nodata: true })}>
                            Set QRCode
                        </button>
                    </div>

                    <div className="admin-part admin-part-2">
                        <div className="animation">
                            <p className="anim-infos">
                                Founder : chercher les objets
                                <br/>
                                Chaise musicale

                                <br/>

                                Test de générosité

                                <br/>

                                Collecte de ballons : enfants

                                <br/>

                                Jeux d'argent : avec des Dés

                                <br/>
                                Alcool / quizz
                            </p>
                        </div>

                        <div className="animations-actions">
                            <input
                                className="birth-input"
                                placeholder="combien ?"
                                type="number"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                            />

                            <input 
                                className="birth-input"
                                placeholder="enfants ? true ou false -- true oui les gosses"
                                onChange={(e) => {
                                    e.preventDefault()
                                    if(e.target.value === "true") {
                                        setchilds(true)
                                    } else {
                                        setchilds(false)
                                    }
                                }}
                            />

                            <button className="birth-button" onClick={handleGetPlayers}>
                                Générer la liste
                            </button>

                            <button className="birth-button" onClick={handleGetItem}>
                                Obtenir un item
                            </button>
                        </div>
                    </div>

                    <div className="admin-part admin-part3">
                        <h2>Joueurs :</h2>
                        {players.length > 0 && (
                            <>
                            {players.map((player, index) => (
                                <div className="admin-list-invite" key={index}>
                                    <span>{player.firstName} {player.lastName} {player.keep ? "✅" : ""}</span>

                                    <button onClick={(e) => {
                                        e.preventDefault()
                                        handleKeepPlayer(player.internId)
                                    }}>
                                        keep
                                    </button>

                                    <button onClick={(e) => {
                                        e.preventDefault()
                                        handleChangePlayer(player.internId)
                                    }}>
                                        replace
                                    </button>
                                </div>
                            ))}
                            </>
                        )}

                        <h2>Item</h2>
                        <span>
                            {item.emoji} {item.name}
                        </span>
                    </div>

                    <div className="admin-part admin-part4">
                        <button onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/timer`, { time: "30s" })}>
                            30 secondes
                        </button>

                        <button onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/timer`, { time: "1m" })}>
                            1 minute
                        </button>

                        <button onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/timer`, { time: "2m" })}>
                            2 minutes
                        </button>

                        <button onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/timer`, { time: "5m" })}>
                            5 minutes
                        </button>
                    </div>

                    <div className="admin-marge" style={{ height: "200px" }}>

                    </div>

                    <div className="admin-part admin-part-5">
                        <button onClick={(e) => handleSendInfo(e, `https://api.kenzo-simon.fr/birthday/admin/reset`, { nodata: true })}>
                            Reset les states
                        </button>
                    </div>

                    <div className="admin-marge" style={{ height: "200px" }}>

                    </div>
                </div>
                </>
            ) : (
                <>
                <input 
                    className="birth-input"
                    placeholder="t'es qui chef ?"
                    onChange={handleVerify}
                />
                </>
            )}
        </div>
    )
}

export default BirthdayAdmin